import { render, staticRenderFns } from "./garbage.vue?vue&type=template&id=3f544bcc&scoped=true&"
import script from "./garbage.vue?vue&type=script&lang=js&"
export * from "./garbage.vue?vue&type=script&lang=js&"
import style0 from "./garbage.vue?vue&type=style&index=0&id=3f544bcc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f544bcc",
  null
  
)

export default component.exports